<template>

	<section 
		:class="wrapClasses"
	>

		<div
			:class="dlClasses" 
		>

			<h2 v-if="title" v-html="title" class="info-panel-title" />

			<p v-if="description" v-html="description" class="info-panel-description" />

			<hr v-if="title || description" />

			<div class="data-list-heading-wrap" v-if="typeof headings.label !== 'undefined' || typeof headings.value !== 'undefined'">

				<h3 :class="['data-list-heading label',{ 'single': typeof headings.value == 'undefined' }]" v-if="typeof headings.label !== 'undefined'" v-html="headings.label" />
				<h3 :class="['data-list-heading value',{ 'single': typeof headings.label == 'undefined'  }]" v-if="typeof headings.value !== 'undefined'" v-html="headings.value" />

			</div><div class="data-list-heading-wrap second" v-if="typeof headings.label !== 'undefined' || typeof headings.value !== 'undefined'">

				<h3 :class="['data-list-heading label',{ 'single': typeof headings.value == 'undefined' }]" v-if="typeof headings.label !== 'undefined'" v-html="headings.label" />
				<h3 :class="['data-list-heading value',{ 'single': typeof headings.label == 'undefined'  }]" v-if="typeof headings.value !== 'undefined'" v-html="headings.value" />

			</div>

			<div :class="{ 'data-list-items': true, 'no-border' : processedItems.length < 3, 'even-number': ( processedItems.length % 2 === 0 ) }">

				<div 
					v-for="(item, itemIndex) in processedItems" 
					:key="itemIndex"   
					:class="[{ 'data-list-item' : true, 'value-only': typeof item.label === 'undefined' }]" 
				>

					<h3 
						v-if="hasLabels && item.label && typeof item.label.click === 'undefined'" 
						:class="['data-list-item-label',{ 'single': !hasValues }]"
						v-html="item.label.value" 
						:title="item.label.value"
					/>
					<h3 
						v-if="hasLabels && item.label && typeof item.label.click !== 'undefined'" 
						:class="['data-list-item-label clickable',{ 'single': !hasValues }]"
						v-html="item.label.value" 
						:title="item.label.value"
						@click="clickItem(item.label)"
					/>
					<h4 
						v-if="item.value && typeof item.value.click === 'undefined' && typeof item.value.href === 'undefined'" 
						:class="['data-list-item-value',{ 'single': !hasLabels }]"
						class="data-list-item-value" 
						:title="item.value.value"
					>{{ item.value.value }}<span v-if="item.value.history && typeof item.value.history.label !== 'undefined'" :class="{ history: true, red: item.value.history.colour === 'red', orange: item.value.history.colour === 'orange', green: item.value.history.colour === 'green' }">{{ item.value.history.label }}</span></h4>
					<h4 
						v-if="item.value && typeof item.value.click !== 'undefined' && typeof item.value.href === 'undefined'" 
						:class="['data-list-item-value clickable',{ 'single': !hasLabels }]"
						:title="item.value.value"
						@click="clickItem(item.value)"
					>{{ item.value.value }}<span v-if="item.value.history && typeof item.value.history.label !== 'undefined'" :class="{ history: true, red: item.value.history.colour === 'red', orange: item.value.history.colour === 'orange', green: item.value.history.colour === 'green' }">{{ item.value.history.label }}</span></h4>

					<h4 
						v-if="item.value && typeof item.value.href !== 'undefined'" 
						:class="['data-list-item-value clickable',{ 'single': !hasLabels }]"
						:title="item.value.value"
					><a :href="item.value.href" :target="item.value.target">{{ item.value.value }}</a></h4>

				</div>

			</div>

			<div class="base-button-wrap">

				<BaseButton v-if="baseButtonSettings" :settings="baseButtonSettings" @clicked="baseButtonClick" />

			</div>

			<InfoPanelOverlay :settings="overlay" @overlayClicked="overlayClicked" />

		</div>

	</section>

</template>

<script>
import { computed } from 'vue';
import BaseButton from './../BaseButton.vue'
import InfoPanelOverlay from './../InfoPanelOverlay.vue'
export default {
	name: 'DataList',
	components: { BaseButton, InfoPanelOverlay },
	props: {
		title: {
			type: String,
			default: null
		},
		description: {
			type: String,
			default: null
		},
		noPad: {
			type: Boolean,
			default: false
		},
		headings: {
			type: Object,
			default: function () {
				return {}
			}
		},
		items: {
			type: Array
		},
		size: {
			type: String,
			default: 'full'
		},
		emitBubble: {
			type: Boolean, 
			default: false
		},
		baseButtonSettings:Object,
		overlay: {
			type: Object,
			default: function () { return {} }
		},
		ratio: {
			type: String,
			default: 'fifty-fifty' // 
		}
	},
	setup(props, { emit }) {
		const hasLabels = computed(() => {
			return props.items && props.items.length > 0 && typeof props.items[0].label !== 'undefined';
		});

		const hasValues = computed(() => {
			return props.items && props.items.length > 0 && typeof props.items[0].value !== 'undefined';
		});

		const processedItems = computed(() => {
			let items = [];
			if (!props.items) return [];
			
			props.items.forEach(function (item) {
				let newItem = {};
				if (typeof item === 'string') {
					newItem = { value: { value: item } };
				} else {
					newItem = item;
				}
				items.push(newItem);
			});
			return items;
		});

		const wrapClasses = computed(() => {
			const c = {};
			c[props.size] = true;
			return c;
		});

		const dlClasses = computed(() => {
			const c = { 
				'info-panel' : props.noPad === false, 
				'data-list': true, 
				'no-margin': props.size !== 'full' && props.size !== 'split', 
				'no-heading' : typeof props.headings.label === 'undefined' && typeof props.headings.value === 'undefined' 
			};

			if (props.headings.ratio) {
				c[props.headings.ratio] = true;
			} else if (props.ratio) {
				props.ratio.split(' ').forEach(function (rr) {
					c[rr] = true;
				});
			}

			props.size.split(' ').forEach(function (rr) {
				c[rr] = true;
			});
			return c;
		});

		const clickItem = (itemInfo) => {
			let cV = typeof itemInfo.clickVars !== 'undefined' ? itemInfo.clickVars : {};
			let c = itemInfo.click;
			
			if (props.emitBubble) {
				c = 'clicked';
				cV = itemInfo;
			}
			emit(c, cV);
		};

		const baseButtonClick = () => {
			emit('base-button-click', props.baseButtonSettings.click);
		};

		const overlayClicked = () => {
			if (props.overlay.click) {
				const cv = props.overlay.clickVars ? props.settings.clickVars : false;
	  			emit(props.overlay.click, cv);
	  		}
		};

		return {
			hasLabels,
			hasValues,
			processedItems,
			wrapClasses,
			dlClasses,
			clickItem,
			baseButtonClick,
			overlayClicked,
		};
	}
}
</script>
<style lang="less" scoped>
@import './../../assets/css/less/_settings.less';
	.data-list {

		.base-button-wrap {

			text-align: center;

		}

		.data-list-heading-wrap {

			text-align: left;
			margin-bottom: 8px;

			&.second {

				display: none;

			}

			.data-list-heading {

				font-size: 14px;
				color: rgba(0,0,0,0.7);
				text-align: left;

			}

		}

		.data-list-items {

			margin-bottom: 10px;

			.data-list-item {

				margin-bottom: 15px;
				border-bottom: 1px dashed rgba(0, 0, 0, 0.07);
			    padding-top: 12px;
			    padding-bottom: 12px;
			    margin-bottom: 0;

			    &:last-child {
				
			    	border-bottom:none;
			    	padding-bottom:0;

				}

			    

				.data-list-item-label {

					font-size: 12px;
					color: rgba(0,0,0,0.7);
					white-space: nowrap;
  					overflow: hidden;
  					font-weight: 400;

				}

				.data-list-item-value {

					font-size: 14px;
					white-space: nowrap;
  					overflow: hidden;

  					&.single {

  						font-size: 12px;
						color: rgba(0,0,0,0.7);

  					}

  					a {
  						color: #000;
  					}

  					.history {

  						padding-left: 2px;
  						font-size: 0.8em;

  						&.red {
							color: @red;
						}
						&.orange {
							color: @orange;
						}
						&.green {
							color: @green;
						}

  					}

				}

				.data-list-item-label, .data-list-item-value {

					&.clickable {

						cursor: pointer;

						&:hover {

							color: @formDefaultColour;

						}

					}

				}

			}

			&.no-border {

				.data-list-item {

					border-bottom:none;

				}

			}

		}

		&.no-heading {

			hr {
				margin-bottom: 2px;
			}

			.data-list-items {

				.data-list-item {

					&:first-child {

						border-top:none;

					}

				}

			}

		}

	}

	.no-pad-all {

		.data-list {

			margin-top: 20px;

			&.no-margin {

				margin-top: 0;

			}

			.data-list-heading-wrap {

				.data-list-heading {



				}

			}

			.data-list-items {

				.data-list-item {

					border-top: 1px dashed rgba(0, 0, 0, 0.07);
				    padding-top: 12px;
				    padding-bottom: 0;
				    margin-bottom: 0;

					.data-list-item-label {

						font-size: 12px;

					}

					.data-list-item-value {



					}

				}

			}

		}

	}

	@media screen and (min-width: 340px) {

		.data-list {

			.data-list-heading-wrap {

				.data-list-heading {

					padding: 0 0 0 10px;
					display: inline-block;
					width: 48%;

				}

			}

			.data-list-items {

				.data-list-item {

					padding-bottom: 8px;
					text-align: left;

					.data-list-item-label {

						display: inline-block;
						width: 48%;
						vertical-align: top;
						text-align: left;
						padding: 2px 0 0 10px;

					}

					.data-list-item-value {

						display: inline-block;
						width: 48%;
						vertical-align: top;
						text-align: left;
						padding-left: 10px;

					}

					&.value-only {

						.data-list-item-value {

							width: 100%;

						}

					}

				}

			}

			&.seventy-thirty {

				.data-list-heading-wrap {

					.data-list-heading {

						&.label {

							width: 68%;

						}

						&.value {
							
							width: 28%;
								
						}

					}

				}

				.data-list-items {

					.data-list-item {

						.data-list-item-label {

							width: 68%;

						}

						.data-list-item-value {

							width: 28%;

						}

					}

				}

			}

			&.thirty-seventy {

				.data-list-heading-wrap {

					.data-list-heading {

						&.label {

							width: 28%;

						}

						&.value {
							
							width: 68%;
								
						}

					}

				}

				.data-list-items {

					.data-list-item {

						.data-list-item-label {

							width: 28%;

						}

						.data-list-item-value {

							width: 68%;

						}

					}

				}

			}

			&.eighty-twenty {

				.data-list-heading-wrap {

					.data-list-heading {

						&.label {

							width: 78%;

						}

						&.value {
							
							width: 18%;
								
						}

					}

				}

				.data-list-items {

					.data-list-item {

						.data-list-item-label {

							width: 78%;

						}

						.data-list-item-value {

							width: 18%;

						}

					}

				}

			}

		}

	}

	@media screen and (min-width: 1024px) {

		.data-list {

			.data-list-heading-wrap {

				vertical-align: top;
				display: inline-block;
				width: 100%;

			}

			.data-list-items {

				vertical-align: top;
				text-align: left;

				.data-list-item {

					vertical-align: top;
					display: inline-block;
					width: 100%;

					&.value-only {

						padding-right: 10px;

						.data-list-item-value {

							width: 100%;
							padding-right:10px;

						}

					}

				}

			}

			&.full, &.split {

				text-align: left;

				.data-list-heading-wrap {

					width: 50%;

					&.second {

						display: inline-block;

					}

					&.data-list-heading {



					}

				}

				.data-list-items {

					.data-list-item {

						width: 50%;

					}

					&.even-number {

						.data-list-item {

							&:nth-last-of-type(-n+2) {

								border-bottom:none;
								padding-bottom:0;

							}

						}

					}

				}

				&.no-heading {

					.data-list-items {

						.data-list-item {

							&:nth-child(2) {

								border-top:none;

							}

						}

					}

				}

			}

		}

	}

</style>